import React from 'react'
import { Link } from 'react-router-dom'
import { faBinoculars, faTrash } from '@fortawesome/free-solid-svg-icons'
import { IconWithHelperText } from '../../../components/TableRow'
import { diffCardTitle } from './ChangeRequestDiffCards'
import FindingsBadge from './FindingsBadge'
import {
  diffCardSummary,
  diffCardTreatment,
  findingsForOperation,
} from './blockChangeHelpers'

const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`

export default function BlocksDraftTray({
  draft,
  canEdit,
  isBusy,
  treatmentNamesById,
  actionLabels,
  onOpen,
  onRemove,
}) {
  if (!draft) return null
  const { change_request: changeRequest, diff_cards: cards, validation } = draft
  const operationFindings = (sequence) => {
    const { errors, warnings } = findingsForOperation({ validation, sequence })
    return [...errors, ...warnings]
  }

  return (
    <div className="box lox-block-change__tray" data-testid="blocks-draft-tray">
      <p className="has-text-weight-semibold mb-1">
        Draft changes ({cards.length})
        <span className="is-size-7 has-text-grey ml-2">
          {plural(validation.errors.length, 'error')} ·{' '}
          {plural(validation.warnings.length, 'warning')}
        </span>
      </p>
      {cards.length === 0 ? (
        <p className="is-size-7 has-text-grey">
          No changes yet. Open a block to edit, override or deactivate it.
        </p>
      ) : (
        <table className="table is-narrow is-fullwidth is-size-7 mb-0 lox-block-change__tray-table">
          <thead>
            <tr>
              <th aria-label="View" />
              <th>#</th>
              <th>Change</th>
              <th>Treatment</th>
              <th>What changes</th>
              <th aria-label="Findings" />
              <th aria-label="Remove" />
            </tr>
          </thead>
          <tbody>
            {cards.map((card) => {
              const treatment = diffCardTreatment({ card, treatmentNamesById })
              const summary = diffCardSummary({ card, actionLabels })
              return (
                <tr
                  key={card.sequence}
                  data-testid={`blocks-draft-tray-item-${card.sequence}`}
                >
                  <td>
                    <button
                      type="button"
                      className="button is-primary is-small lox-view-button"
                      aria-label={`View change ${card.sequence}`}
                      onClick={() => onOpen(card)}
                      data-testid={`blocks-draft-tray-view-${card.sequence}`}
                    >
                      <IconWithHelperText
                        icon={faBinoculars}
                        helperText="View block"
                      />
                    </button>
                  </td>
                  <td className="has-text-grey">{card.sequence}</td>
                  <td>
                    {diffCardTitle(card)}
                    {card.name && (
                      <span className="has-text-grey"> · {card.name}</span>
                    )}
                  </td>
                  <td>
                    {treatment && (
                      <span className="tag is-light lox-no-border">
                        {treatment}
                      </span>
                    )}
                  </td>
                  <td className="has-text-grey">{summary}</td>
                  <td>
                    <FindingsBadge
                      findings={operationFindings(card.sequence)}
                    />
                  </td>
                  <td>
                    {canEdit && (
                      <button
                        type="button"
                        className="button is-danger is-small lox-view-button"
                        aria-label={`Remove change ${card.sequence}`}
                        disabled={isBusy}
                        onClick={() => onRemove(card.sequence)}
                        data-testid={`blocks-draft-tray-remove-${card.sequence}`}
                      >
                        <IconWithHelperText
                          icon={faTrash}
                          helperText="Remove change"
                        />
                      </button>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
      <Link
        className="button is-small is-primary mt-2"
        to={`/lead_funnel_block_change_requests/${changeRequest.id}`}
      >
        {canEdit ? 'Review and submit' : 'View change request'}
      </Link>
    </div>
  )
}
